<script>
  import { onMount } from 'svelte';
  import { headerDisplayStore } from '../stores/General';
  import Wrapper from '../components/dashboard/Wrapper.svelte';
  import { sendPostRequest } from '../api/crud';

  let emptdata = {
    widgets: {
      bid_request: { count: 0, delta: 0 },
      bid_response: { count: 0, delta: 0 },
      impressions: { count: 0, delta: 0 },
      revenue: { count: 0, delta: 0 },
      margin: { count: 0, delta: 0 },
    },
    charts: {
      category: [],
      ad_requets_and_responses: {
        series: [
          { seriesname: 'Ad Requests', data: [] },
          { seriesname: 'Ad Responses', data: [] },
        ],
      },
      impressions_and_revenue: {
        series: [
          { seriesname: 'Impressions', data: [] },
          { seriesname: 'Revenue', data: [] },
        ],
      },
      demandrevenue_and_margin: {
        series: [
          { seriesname: 'Margin', data: [] },
          { seriesname: 'Net Revenue', data: [] },
        ],
      },
      margin: 0,
    },
  };

  const req = sendPostRequest('/dashboard/get');

  const config = {
    topWidgets: [
      { name: 'Bid Requests', key: 'bid_request', type: 'sum' },
      { name: 'Bid Responses', key: 'bid_response', type: 'sum' },
      { name: 'Impressions', key: 'impressions', type: 'sum' },
      { name: 'Profit', key: 'revenue', type: 'sum', prefix: '$' },
      { name: 'Margin', key: 'margin', type: 'percent', suffix: '%' },
    ],
    charts: [
      {
        caption: 'Requests & Responses',
        key: 'ad_requets_and_responses',
        type: 'mscombidy2d',
        options: [{ index: 1, renderAs: 'line', parentYAxis: 'S' }],
      },
      {
        caption: 'Impressions & Profit',
        key: 'impressions_and_revenue',
        sNumberPrefix: '$',
        type: 'mscombidy2d',
        options: [{ index: 1, renderAs: 'area', parentYAxis: 'S', seriesname: 'Profit' }],
      },
      {
        caption: 'Demand Partner Net Revenue & Margin',
        key: 'demandrevenue_and_margin',
        sNumberPrefix: '',
        type: 'mscombidy2d',
        options: [{ index: 0, renderAs: 'area', parentYAxis: 'S', seriesname: 'Margin' }],
        theme: 'gammel',
      },
    ],
    widgets: [{ name: 'Margin', key: 'margin', type: 'percent' }],
  };

  onMount(async () => {
    headerDisplayStore.SetTitle('Dashboard');
    headerDisplayStore.SetBreadCrumbs([
      {
        key: 'dashboard',
        label: 'Dashboard',
      },
    ]);
  });
</script>

<div class="py-6">
  <div class="max-w-full mx-auto px-4 sm:px-6 md:px-8">
    {#await req}
      <Wrapper {config} loading={true} />
    {:then res}
      <Wrapper data={res.data} {config} loading={false} />
    {:catch}
      <Wrapper data={emptdata} {config} loading={false} />
      {/await}
    </div>
  </div>
